import { UserID } from "./User";

export enum USER_SESSION_TYPES {
  Web = 1,
  Tablet = 2
}

export interface UserSession {
  token: string;
  user_id: UserID;
  type: USER_SESSION_TYPES;
  expire_at: string;
}
